import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DateTimeComponentBase } from '../base/date-time.base';
import { LanguageService } from '../../service/language.service';

@Component({
    selector: 'app-date-box',
    templateUrl: './date-box.component.html',
    styleUrls: ['./date-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateBoxComponent extends DateTimeComponentBase implements OnInit {
  constructor(languageService: LanguageService) {
    super(languageService);
  }

  ngOnInit() {}
}
